export const TEST = 'Hello';

export const deploymentName = 'pephealthappstaging';
export const envName = 'pephealth-staging';

export const domain = 'staging.au.pephealthapp.com';

// General App config
export const appToken = '405a64';
export const appId = 1;
export const ubiquityCompanyId = 4;
// "staging-forpatientapp-staff" Cognito User Pool
export const userPoolId = 'ap-southeast-2_EmgGXCgCA';
export const userPoolAppClient = '3tug6bp98aqase3919092kdgt';

// IDM
export const idmOrganisation = 2;
export const organisationSlug = 'fpa';
export const idmApiRoot = `https://idm.${domain}/`;
export const organisationUrl = `${idmApiRoot}api/v1/organisations/`;
export const idmLogin = `https://idm.${domain}/api/login/`;
export const idmLogout = `https://idm.${domain}/logout/`;
// export const idmTokens = `https://idm.${domain}/api/tokens/`;

export const pepHealthApiRoot = `https://pephealth.${domain}/`;

// CMS apps
export const carbonURL = `https://carbon.${domain}`;
export const ubiquityURL = `https://ubiquity.${domain}`;

// UIS
export const uisApiRoot = `https://uis.${domain}/`;

// PIP
export const pipApiRoot = `https://pip.${domain}`;
export const pipAppUrl = `https://pip.${domain}/api/admin/v1/apps/`;

export const ubiquityApiRoot = `https://ubiquity.${domain}/`;
export const pathwaysApiRoot = `https://pathways.${domain}/v1/apps/{{app_ubiquity_token}}/`;

export const messagingApiRoot = `https://ubiquity.${domain}/api/core/v1/apps/`;

export const organisationDirectoryApiRoot = `https://directory.${domain}/api/v1/`;

export const videoCreationEndpoint = `https://6emgs0npii.execute-api.ap-southeast-2.amazonaws.com/staging/create`;
export const videoExportStatusEndpoint = `https://6emgs0npii.execute-api.ap-southeast-2.amazonaws.com/staging/export_status`;
export const videoCEDetails = {
  ce_space_uuid: '601d42ce-f3b2-48e1-9be9-847b9dedbf3e',
  ce_category_slug: 'uploaded-videos',
  template_name: 'pep-health-video-en',
};
export const videoUbiquityExportDetails = {
  theme_slug: 'default-theme',
  ubiquity_app_id: appId,
  ubiquity_company_id: ubiquityCompanyId,
  ubiquity_category_ids: ['2'],
};

export const mixpanelToken = '49be1ec2d8b0c80de23ce0bb07f9f70f';
export const mixpanelOptions = {
  // disable_persistence: true
  // api_host: "https://api-eu.mixpanel.com",
};
export const analyticsHiddenSuperProperties = ['firstName', 'lastName', 'name'];

export const metricsUrlRoot = '';

export const documentTemplateUrl =
  'https://pephealthapp-assets.s3.ap-southeast-2.amazonaws.com/Document+Templates.zip';

export const FEATURES = {
  help: {
    url: 'https://liquidstate.atlassian.net/wiki/spaces/PDKB/overview',
  },
  // remove the display and tracking of Terms & Conditions and Privacy Policy (instead have short text for TCs and link to Privacy Policy doc)
  noTermsTrackingForDashboardUsers: false,
  appUsersControlledDocsForAllOrgs: false,
  showDataRequestsForHospitalUsers: false,
  evereg: false,
  pathwayLibrary: true,
  ucidIsRequired: false,
  ucidIsMod3736: false,
  externalVideoProviders: ['movingimage'],
};

export const envHasDataLake = true;
export const dataLakeBaseURL =
  'https://f7pn4ihij9.execute-api.ap-southeast-2.amazonaws.com/staging/admin_user_file_url';
export const dataLakeFormDataDownloadURL = `${dataLakeBaseURL}?application=form_submissions_csv&path=by_form/FORM_ID/all.csv`;
export const dataLakeFormDataDownloadForAppUserURL = `${dataLakeBaseURL}?application=form_submissions_csv&path=by_app_user/APP_USER_ID/FORM_ID.csv`;

export const restrictSharedSnapshotsCreation = false;

export const showAppUserHealthDataScreen = true;

export const kemtaiPatientURL = 'https://care-manage.kemtai.com/users/KEMTAI_ID';

export const superUserCreatesManagedPathwayByDefault = false;
